import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const picker = css`
  position: relative;

  & > :last-child {
    ::before {
      content: '';
      block-size: 100%;
      position: absolute;
      inset-block-start: -100%;
      inset-inline-start: 0;
      inset-inline-end: 0;
      background-color: ${cssTheme.colors.absolute.white};
      opacity: 0.5;
    }

    ::after {
      content: '';
      block-size: 100%;
      position: absolute;
      inset-block-end: -100%;
      inset-inline-start: 0;
      inset-inline-end: 0;
      background-color: ${cssTheme.colors.absolute.white};
      opacity: 0.5;
    }
  }
`
